<button mat-icon-button [matMenuTriggerFor]="preview">
  <mat-icon>shopping_bag</mat-icon>
</button>

<mat-menu #preview="matMenu"> <greco-cart-preview></greco-cart-preview> </mat-menu>
